import Joi from "joi";

const RelationshipMasterSchema = Joi.object({
  relationshipName: Joi.string().trim().required().messages({
    "string.empty": "Relationship Name is required.",
  }),
}).unknown(true);

export default RelationshipMasterSchema;
